/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import * as React from 'react';
import { Page, Form, Button, Card, Icon } from 'tabler-react';
import Cookies from 'js-cookie';
import axios from 'axios';
import toast from 'cogo-toast';

import Request from '../../shared/request';
import banner from '../../assets/login_banner.jpg';

import PageComponent from '../PageComponent';
import './login.scss';
import wechat from './social-wechat.svg';
import googleIcon from './social-google.svg';

class Login extends PageComponent {
  state = {
    forward: '/dashboard',
    isProcessing: false,
    email: '',
    password: '',
    auto: false,
    wechatModal: false,
    qrcodeURL: '',
    qrcodeBase64: '',
    UUID: '',
    wechatMessage: '',
    tab: 'email',
    phone: '',
    areacode: '86',
  };

  componentDidMount() {
    const search = new URLSearchParams(window.location.search);
    const returnURL =
      search.get('forward') || search.get('return_to') || '/dashboard';
    this.setState({
      forward: returnURL,
    });
    this.initGoogle();
  }

  componentWillMount() {
    const searchParams = new URLSearchParams(window.location.search);
    const login = searchParams.get('login');
    if (login) {
      const [email, password] = atob(login).split(':');
      this.setState({ email, password, auto: true });
    }
  }

  login = async e => {
    e.preventDefault();
    this.setState({ isProcessing: true });
    const { email, password, phone, areacode } = this.state;
    let { forward } = this.state;
    const body = { password };
    if (this.state.tab === 'email') {
      body.email = email;
    } else {
      body.phone = `+${areacode}${phone}`;
    }
    const userInfo = await Request.call('loginUser', body);
    if (userInfo) {
      this.saveToken(userInfo);
      if (forward && forward.indexOf('malus.zendesk.com') > -1) {
        forward = `https://getmalus.com/api/loginZendesk?token=${userInfo.token
          }`;
      }
      window.location.href = forward || '/dashboard';
    }
    this.setState({ isProcessing: false });
  };

  autoLogin = async e => {
    const { email, password, forward } = this.state;
    const userInfo = await Request.call('loginUser', { email, password });
    if (userInfo) {
      this.saveToken(userInfo);
      window.location.href = forward || '/dashboard';
    }
    this.setState({ isProcessing: false });
  };

  saveToken = userInfo => {
    if (userInfo) {
      localStorage.setItem('login', JSON.stringify(userInfo));
      Cookies.set('malus-token', userInfo.token, {
        domain: `.${window.location.host
          .split('.')
          .slice(-2)
          .join('.')}`,
      });
    }
  };

  googleSuccess = async googleUser => {
    toast.info('Google 登陆跳转中...');
    const authProfile = googleUser.getAuthResponse();
    const identityToken = authProfile.id_token;

    if (identityToken) {
      const data = await Request.call('loginByOauth', {
        identityToken,
        type: 'google',
      });
      if (data && data.token) {
        this.saveToken(data);
        window.location.href = this.state.forward || '/dashboard';
      }
    }
  };

  googleFailure = error => {
    toast.warn(error.message || '已取消 Google 登陆');
  };

  initGoogle = () => {
    // Google登录
    window.gapi.load('auth2', () => {
      console.log('gapi.init');
      const auth2 = window.gapi.auth2.init({
        client_id:
          '350873246284-v0tiev04cou3boonop1o4tl3u69ieeai.apps.googleusercontent.com',
        cookiepolicy: 'single_host_origin',
        scope:
          'https://www.googleapis.com/auth/plus.login https://www.googleapis.com/auth/userinfo.email',
      });
      // https://developers.google.com/identity/sign-in/web/reference#gapiauth2signinoptions
      auth2.attachClickHandler(
        'google-login',
        { prompt: 'select_account' },
        this.googleSuccess,
        this.googleFailure,
      );
    });
  };

  getUserInfo = async authorizationCode => {
    const data = await Request.call('loginByOauth', {
      type: 'wechat',
      authorizationCode,
    });
    if (data) {
      this.saveToken(data);
      this.setState({
        wechatMessage: `${data.displayName} 登陆成功，正在跳转...`,
      });
      setTimeout(() => {
        window.location.href = this.state.forward || '/dashboard';
      }, 2000);
    }
  };

  getCode = async (uuid, time) => {
    const { status, result } = await Request.call(`getWechatCode?uuid=${uuid}&_=${time}`)
    switch (status) {
      case 405:
        // 登陆成功
        this.setState({ wechatMessage: '正在登陆...' });
        this.getUserInfo(result.code);
        break;
      case 404:
        this.setState({ wechatMessage: '手机已扫描' });
        // 继续poll
        setTimeout(() => {
          this.getCode(this.state.UUID, Date.now());
        }, 1000);
        // 扫描成功
        break;
      case 403:
        this.setState({ wechatMessage: '', wechatModal: false });
        toast.warn('微信登陆已取消');
        // 取消本次登陆
        break;
      case 402:
      case 500:
        this.getUUID();
        // 重新获取uuid
        break;
      case 408:
        // 继续poll
        setTimeout(() => {
          this.getCode(window.wechatUUID, Date.now());
        }, 1000);
        break;
      default:
        break;
    }
  };

  getUUID = async () => {
    this.setState({ wechatModal: true });
    const data = await Request.call('getWechatLoginCode');
    if (data) {
      this.setState({ qrcodeBase64: data.qrcodeURL, UUID: data.UUID });
      this.getCode(this.state.UUID, Date.now());
    }
  };

  render() {
    const { auto, email, password } = this.state;
    return (
      <Page className="page-login">
        {auto ? (
          <Card className="form-card">
            <Card.Header>
              <Card.Title>登录信息</Card.Title>
            </Card.Header>
            <Card.Body>
              <div>
                账号：<strong>{email}</strong>
              </div>
              <div>
                密码：<strong>{password}</strong>
              </div>
            </Card.Body>
            <Card.Footer className="warning-message">
              <p>
                <i className="fe fe-bell mr-2" />
                请保存账号密码
              </p>
              <Button
                color="info"
                loading={this.state.isProcessing}
                pill
                onClick={this.autoLogin}>
                确定登录
              </Button>
            </Card.Footer>
          </Card>
        ) : (
            <Card className="form-card login">
              <a className="brand" href="/">
                <img src={banner} alt="" />
              </a>
              <Card.Body className="right">
                <div className="sign-tab">
                  <h3
                    onClick={() => this.setState({ tab: 'email' })}
                    className={this.state.tab === 'email' ? 'active' : ''}>
                    邮箱登录
                </h3>
                  <h3
                    onClick={() => this.setState({ tab: 'phone' })}
                    className={this.state.tab === 'phone' ? 'active' : ''}>
                    手机登录
                </h3>
                </div>
                {this.state.tab === 'phone' ? (
                  <Form
                    className="email-sign"
                    autoComplete="off"
                    onSubmit={this.login}>
                    <div className="phone-group">
                      <div className="plus">+</div>
                      <Form.Input
                        feedback="Invalid feedback"
                        placeholder="区号"
                        value={this.state.areacode}
                        onChange={e =>
                          this.setState({ areacode: e.target.value })
                        }
                        className="area"
                      />
                      <Form.Input
                        feedback="Invalid feedback"
                        placeholder="输入手机号"
                        onChange={e => this.setState({ phone: e.target.value })}
                        className="number"
                      />
                    </div>
                    <Form.Input
                      type="password"
                      value={this.state.password}
                      placeholder="输入密码"
                      onChange={e => this.setState({ password: e.target.value })}
                    />
                    <Button
                      loading={this.state.isProcessing}
                      onClick={this.login}
                      color="primary">
                      立即登录
                  </Button>
                  </Form>
                ) : (
                    <Form
                      className="email-sign"
                      autoComplete="off"
                      onSubmit={this.login}>
                      <Form.Input
                        value={this.state.email}
                        feedback="Invalid feedback"
                        placeholder="输入邮箱"
                        onChange={e => this.setState({ email: e.target.value })}
                      />
                      <Form.Input
                        type="password"
                        value={this.state.password}
                        placeholder="输入密码"
                        onChange={e => this.setState({ password: e.target.value })}
                      />
                      <Button
                        loading={this.state.isProcessing}
                        onClick={this.login}
                        color="primary">
                        立即登录
                  </Button>
                    </Form>
                  )}

                <div className="form-bottom">
                  <a
                    href="/signup?utm_source=dashboard&utm_medium=signin"
                    target="_self">
                    注册账号
                </a>
                  <a href="/dashboard/forgot">忘记密码？</a>
                </div>
                <div className="social-login">第三方登录/注册</div>
                <div className="social-btn-group">
                  <div className="btn-social" onClick={this.getUUID}>
                    <img src={wechat} alt="wechat" />
                    <span>微信</span>
                  </div>
                  <div className="btn-social" id="google-login">
                    <img src={googleIcon} alt="wechat" />
                    <span>Google</span>
                  </div>
                </div>
                {/* <div
                  className={`wechat-login ${this.state.wechatModal ? '' : 'hidden'
                    }`}>
                  <Card className="content">
                    <Card.Header>
                      <Card.Title>
                        <img src={wechat} alt="wechat" />
                      使用微信扫码登录或注册
                    </Card.Title>
                      <div
                        className="closed"
                        onClick={() =>
                          this.setState({ wechatModal: false, wechatMessage: '' })
                        }>
                        <Icon name="x" />
                      </div>
                    </Card.Header>
                    <Card.Body>
                      <div className="qrcode">
                        <img src={this.state.qrcodeBase64} alt="" />
                      </div>
                      <span className="wechat-message">
                        {this.state.wechatMessage}
                      </span>
                    </Card.Body>
                  </Card>
                </div> */}
              </Card.Body>
            </Card>
          )}
      </Page>
    );
  }
}

export default Login;
